<template>
  <el-card class="sh-card" v-bind="$attrs" v-on="$listeners" :body-style="bodyStyle" :shadow="shadow">
    <slot v-for="(_, name) in $slots" :name="name"></slot>
  </el-card>
</template>

<script>
export default {
  name: 'ShCard',
  props: {
    bodyStyle: {
      type: Object,
      default: () => ({ padding: '10px' })
    },
    shadow: {
      type: String,
      default: 'hover'
    }
  },

  computed: {}
}
</script>

<style></style>
